import { useMutation, useQueryClient } from "@tanstack/react-query";
import i18next from "i18next";
import { ApiCustodyReinvest } from "@/api";
import {
  CustodyReinvestResultCode,
  type CustodyReinvestRequest,
  type CustodyReinvestResponse,
} from "@/api/types";
import { showError } from "@/lib/toast";

/** 与 {@link CustodyReinvestResultCode} 一一对应的 i18n key（`toast.custody.reinvest.result.*`） */
export const CUSTODY_REINVEST_RESULT_I18N_KEY: Record<
  Exclude<CustodyReinvestResultCode, CustodyReinvestResultCode.Success>,
  string
> = {
  [CustodyReinvestResultCode.MissingAgreementVersion]:
    "toast.custody.reinvest.result.missingAgreementVersion",
  [CustodyReinvestResultCode.NoPendingUsdt]:
    "toast.custody.reinvest.result.noPendingUsdt",
  [CustodyReinvestResultCode.BelowMinReinvest]:
    "toast.custody.reinvest.result.belowMinReinvest",
  [CustodyReinvestResultCode.AgreementNotSigned]:
    "toast.custody.reinvest.result.agreementNotSigned",
  [CustodyReinvestResultCode.UtcDayMismatch]:
    "toast.custody.reinvest.result.utcDayMismatch",
  [CustodyReinvestResultCode.TargetStatusInvalid]:
    "toast.custody.reinvest.result.targetStatusInvalid",
  [CustodyReinvestResultCode.ExceedMonthlyQuota]:
    "toast.custody.reinvest.result.exceedMonthlyQuota",
  [CustodyReinvestResultCode.Busy]: "toast.custody.reinvest.result.busy",
  [CustodyReinvestResultCode.Exception]:
    "toast.custody.reinvest.result.exception",
};

export function mapCustodyReinvestResultCodeToI18nKey(
  resultCode: number
): string {
  const key =
    CUSTODY_REINVEST_RESULT_I18N_KEY[
      resultCode as keyof typeof CUSTODY_REINVEST_RESULT_I18N_KEY
    ];
  return key ?? "toast.custody.reinvest.result.unknown";
}

export function useCustodyReinvest() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (
      data: CustodyReinvestRequest
    ): Promise<CustodyReinvestResponse> => {
      const res = await ApiCustodyReinvest(data);
      console.log("ApiCustodyReinvest", res);
      return res.data;
    },
    onSuccess: data => {
      const code = Number(data.resultCode);
      if (code === CustodyReinvestResultCode.Success && data.ok) {
        queryClient.invalidateQueries({ queryKey: ["custodyOrders"] });
        queryClient.invalidateQueries({ queryKey: ["userCustodyInfo"] });
        queryClient.invalidateQueries({ queryKey: ["balanceV2"] });
        queryClient.invalidateQueries({
          queryKey: ["custodyStaticClaimLines"],
        });
        return;
      }
      showError(i18next.t(mapCustodyReinvestResultCodeToI18nKey(code)));
    },
  });
}
